import styled from 'styled-components';

export const Chips = styled.div`
  > div {
  
  }
`;
